export default __webpack_public_path__ + "static/media/981.4c768ab7.png";